/* eslint-disable import/no-unresolved */
import { Dayjs } from "dayjs";
import { FilterOptions } from "src/helpers/Dashboard/interface";
import * as types from "../../Types/dashboard";

export const setTableData = (payload: any) => ({
  type: types.SET_TABLE_DATA,
  payload
});

export const setDashboardData = (payload: any) => ({
  type: types.SET_DASHBOARD_DATA,
  payload
});

export const searchDashboardData = (payload: string) => ({
  type: types.SEARCH_QUERY,
  payload
});
export const setSearchOnDashboard = (payload: string) => ({
  type: types.SEARCH_ON,
  payload
});
export const setDateFiltersDashboard = (payload: {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}) => ({
  type: types.DATE_FILTERS,
  payload
});

export const setSortBy = (payload: any) => ({
  type: types.SORT_BY,
  payload
});

export const setPageNo = (payload: number) => ({
  type: types.PAGE_NO,
  payload
});

export const setLimit = (payload: number) => ({
  type: types.SET_LIMIT,
  payload
});

export const setFilterSaved = (payload: boolean) => ({
  type: types.SET_FILTER_SAVED,
  payload
});

export const setFilterOptions = (payload: FilterOptions) => ({
  type: types.SET_FILTER_OPTIONS,
  payload
});
